import React, {Component} from "react";

export default class SuccessAlert extends Component {

    constructor (props) {

        super(props);

    }

    handleClick () {

        this.props.action();

    }

    render () {

        return (
            <div
                className={this.props.error ? "alert error-upload alert-dismissible successAlert" : "alert alert-success alert-dismissible successAlert"  }  
                role="alert"
            >
                <button
                    className="close"
                    data-dismiss="alert"
                    onClick={this.handleClick.bind(this)}
                    type="button"
                >
                    &times;
                </button>
                <strong>
                    {this.props.message ? this.props.message : "Changes have been saved."}
                </strong>
            </div>
        );

    }

}
